import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Services.css";

const Services = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 },
    );

    document.querySelectorAll(".fade-in").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: "🎓",
      title: "Training & Entrepreneurship",
      slug: "training",
      description:
        "Build the career or business you deserve with expert training in business, technology, and entrepreneurship",
      highlights: ["Business Leadership", "Tech Skills", "Startup Support"],
    },
    {
      icon: "☀️",
      title: "Solar Energy Solutions",
      slug: "solar",
      description:
        "Clean, reliable power that guarantees you never lack energy for your upgraded lifestyle",
      highlights: ["Custom Design", "Installation", "Maintenance"],
    },
    {
      icon: "🏥",
      title: "Remote Healthcare",
      slug: "healthcare",
      description:
        "Top-tier medical care from anywhere to restore balance when illness or fatigue comes knocking",
      highlights: ["Video Consultations", "Health Monitoring", "24/7 Support"],
    },
    {
      icon: "🏡",
      title: "Smart Real Estate",
      slug: "real-estate",
      description:
        "Build wealth through intelligent property solutions - from smart homes to investment advisory",
      highlights: ["Smart Homes", "Property Investment", "Construction"],
    },
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="hero-particles"></div>
        <div className="container">
          <div className="services-hero-content fade-in">
            <h1 className="services-hero-title">
              Our <span className="gradient-text">Services</span>
            </h1>
            <p className="services-hero-subtitle">
              Comprehensive solutions for career, energy, health, and wealth -
              integrated into one seamless ecosystem
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="main-services">
        <div className="container">
          <div className="services-grid-modern">
            {services.map((service, index) => (
              <Link
                key={index}
                to={`/services/${service.slug}`}
                className="service-card-modern fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="service-card-content">
                  <div className="service-icon-large">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p className="service-desc">{service.description}</p>

                  <ul className="service-highlights">
                    {service.highlights.map((highlight, idx) => (
                      <li key={idx}>{highlight}</li>
                    ))}
                  </ul>

                  <span className="learn-more">
                    Learn More <span className="arrow">→</span>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta fade-in">
        <div className="container">
          <div className="cta-content">
            <h2>Need Help Choosing?</h2>
            <p>
              Our team is here to help you find the perfect solution for your
              needs
            </p>
            <Link to="/contact-us" className="btn btn-light">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
